import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiCloud, FiCpu, FiLayers, FiLock, FiMaximize } = FiIcons;

const features = [
  { icon: FiCpu, text: "High-Density Access Points" },
  { icon: FiLayers, text: "Managed PoE Switches" },
  { icon: FiLock, text: "Next-Gen Firewalls & VPNs" },
  { icon: FiCloud, text: "Centralized Cloud Management" },
  { icon: FiMaximize, text: "Seamless Multi-Site Networking" },
];

const UbiquitiFocus = () => {
  return (
    <section id="ubiquiti" className="py-24 bg-slate-900 text-white relative overflow-hidden">
      {/* Abstract Background Shapes */}
      <div className="absolute top-0 right-0 -mr-40 -mt-40 w-96 h-96 rounded-full bg-blue-600/10 blur-3xl"></div>
      <div className="absolute bottom-0 left-0 -ml-40 -mb-40 w-96 h-96 rounded-full bg-cyan-500/10 blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-16">
          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, x: -30 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h2 className="text-sm font-bold tracking-widest text-blue-400 uppercase mb-3">Powered by Ubiquiti</h2>
              <h3 className="text-3xl md:text-5xl font-bold mb-6">Enterprise Performance, Simplified Management.</h3>
              <p className="text-slate-300 text-lg mb-8 leading-relaxed">
                We specialize in designing and deploying Ubiquiti UniFi ecosystems. Experience unparalleled wireless coverage, robust security, and deep visibility into your network traffic, all managed through a single intuitive interface.
              </p>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
                {features.map((feature, idx) => (
                  <div key={idx} className="flex items-center gap-3">
                    <div className="bg-slate-800 p-2 rounded-lg text-blue-400">
                      <SafeIcon icon={feature.icon} />
                    </div>
                    <span className="font-medium text-slate-200">{feature.text}</span>
                  </div>
                ))}
              </div>

              <a href="#contact" className="inline-flex items-center justify-center bg-white text-slate-900 hover:bg-gray-100 px-8 py-3 rounded-md font-bold transition-colors">
                Get a Network Assessment
              </a>
            </motion.div>
          </div>

          <div className="w-full lg:w-1/2">
            <motion.div
              initial={{ opacity: 0, scale: 0.9 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
              className="relative"
            >
              <img 
                src="https://eas-pr.com/wp-content/uploads/2018/03/Product-Spotlight-UniFi%C2%AE-Enterprise-Wi-Fi-System-by-Ubiquiti.jpg" 
                alt="Ubiquiti UniFi Enterprise System" 
                className="rounded-2xl shadow-2xl border border-slate-700 w-full h-auto object-cover"
              />
              {/* Floating stat card */}
              <div className="absolute -bottom-6 -left-6 bg-slate-800 border border-slate-600 p-6 rounded-xl shadow-xl max-w-xs">
                <div className="text-3xl font-bold text-white mb-1">99.99%</div>
                <div className="text-sm text-slate-400">Network Uptime Reliability with proper UniFi deployment.</div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default UbiquitiFocus;